// extracted by mini-css-extract-plugin
export var chip = "_rh-0";
export var icon = "_rh-1";
export var remove = "_rh-2";
export var removeIcon = "_rh-3";